// Format date + time like "11/17/25 1:15pm"
export function formatDateTime(dateString) {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const month = String(date.getMonth() + 1).padStart(2, "0"); // 1-based month
    const day = String(date.getDate()).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2); // last 2 digits

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    if (hours === 0) hours = 12;

    return `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
  } catch (e) {
    return dateString;
  }
}

// Format date only like "11/17/25"
export function formatDate(dateString) {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);

    return `${month}/${day}/${year}`;
  } catch (e) {
    return dateString;
  }
}

// Format time only like "1:15pm"
export function formatTime(dateString) {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    if (hours === 0) hours = 12;

    return `${hours}:${minutes}${ampm}`;
  } catch (e) {
    return dateString;
  }
}
